import { useEffect, useRef, useState } from 'react';
import s from './CreateCourse.module.scss';
import { TextFieldsBlock } from 'components/TextFieldsBlock/TextFieldsBlock';
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { useSelector } from 'react-redux';
import { StyledNumberInput } from 'components/StyledNumberInput/StyledNumberInput';
import { Checkbox, MenuItem, Select, Slider } from '@mui/material';
import DatePicker from 'react-datepicker';
import { Modules } from './components/modules/Modules';
import { PrimaryButton } from 'components/PrimaryButton/PrimaryButton';
import { SecondaryButton } from 'components/SecondaryButton/SecondaryButton';
import { useCreateCourseMutation, useDeleteCourseMutation, useDeleteLessonsMutation, useDeleteModulesMutation, useGetCourseMutation, useUpdateCourseMutation } from '../../../../redux/apis/coursesApi';
import { validationCourse } from 'utils/validation';
import { useStatusContext } from 'components/StatusProvider';
import { CourseCardBlock } from './components/CourseCardBlock/CourseCardBlock';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DropdownBlock } from 'components/DropdownBlock/DropdownBlock';
import { ReactComponent as Arrow } from "../../../../assets/icons/arrow_tools.svg";
import { Skeleton } from 'components/Skeleton/Skeleton';
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete_icon2.svg"
import { ModalGeneral } from 'components/Modals/ModalGeneral';
import { useTranslation } from 'react-i18next';
import questionMark from "assets/images/questionMark.webp";
import { useGetTagsQuery } from '../../../../redux/apis/tagsApi';
const URL = process.env.REACT_APP_API_ADDRESS

export const CreateCourse = () => {

    // ### State
    const [form, setForm] = useState<any>({
        id: undefined,
        image: undefined,
        card_name: undefined,
        active_card_name: false,
        card_description: undefined,
        active_card_description: false,
        card_button_text: undefined,
        active_card_button_text: false,
        name: undefined,
        description: undefined,
        price: undefined,
        active_price: false,
        discount: undefined,
        active_discount: false,
        discount_text: undefined,
        date: new Date().toISOString(),
        active_valid_date: false,
        valid_date: undefined,
        strict: undefined,
        level: 0,
        slug: undefined,
        modules: [],
        tag: undefined
    })
    const langs = useSelector((store: any) => store.main.langs);
    const [activeLang, setActiveLang] = useState<string>(langs?.[0]?.key)
    const [dropdown, setDropDown] = useState({main: true, card: false, modules: false})
    const [showDeleteModal, setShowDeleteModal] = useState<any>(false);
    const [showTagModal, setShowTagModal] = useState<any>(false);
    const [deletedModules, setDeletedModules] = useState<any[]>([])
    const [deletedLessons, setDeletedLessons] = useState<any[]>([])
    const { openStatus } = useStatusContext();
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const id = searchParams.get('id')
    const {t} = useTranslation()

    const discount_ref = useRef<HTMLDivElement>(null)

    const [GetCourse, {isLoading: isGetLoading}] = useGetCourseMutation()
    const [CreateCourse, {isLoading: isCreateLoading}] = useCreateCourseMutation()
    const [UpdateCourse, {isLoading: isUpdateLoading}] = useUpdateCourseMutation()
    const [DeleteModule, {isLoading: isDeleteModuleLoading}] = useDeleteModulesMutation()
    const [DeleteLesson, {isLoading: isDeleteLessonLoading}] = useDeleteLessonsMutation()
    const [DeleteCourse, {isLoading: isDeleteCourseLoading}] = useDeleteCourseMutation()
    const {data: tags, isLoading: isGetTagsLoading} = useGetTagsQuery({})
   
    // ### Effects
    // useEffect(()=>{
    //     console.log("#################", form);
    // },[form]); 

    useEffect(()=>{
        if(tags?.length && !form?.tag) setForm((prev: any) => ({...prev, tag: tags?.[0]?.name}))
    },[tags]);

    useEffect(()=>{
        if(id) handleGetCourse(Number(id))
    },[id]);

    useEffect(()=>{
        if(form.active_discount){
            setTimeout(()=>{
                if(discount_ref.current){
                    discount_ref.current.style.cssText = `height: ${discount_ref.current.scrollHeight}px`
                }
            },1000)
        } else{
            setTimeout(()=>{
                if(discount_ref.current){
                    discount_ref.current.style.cssText = `0px`
                }
            },1000)
        }
    },[form.active_discount]);

    // ### Functions

    function modifyImageData(image: any){
        return Object.entries(image)?.reduce((acc: any, el: any) => {
            if(el[0] === "default_image" || el[0] === "isManual"){
                acc[el[0]] = el[1]
            }else{
                acc[el[0]] = `${URL?.slice(0, -1)}${el[1]}`
            }
            return acc
        },{})
    }
    async function handleGetCourse(id: number){
        
        const response = await GetCourse({id})
        setForm({
            ...response?.data?.courses?.[0],
            image: modifyImageData(response?.data?.courses?.[0]?.image),
            modules: response?.data?.courses?.[0]?.modules?.map((mod: any) => ({
                ...mod,
                image: mod.image ? modifyImageData(mod.image) : undefined,
                lessons: mod.lessons?.map((les: any) => ({
                    ...les,
                    preview: les.preview ? modifyImageData(les.preview) : undefined,
                    video: les.video ? modifyImageData(les.video) : undefined
                }))
            }))
        })
    }

    function modifyImageState(image: any){
        return Object.entries(image)?.reduce((acc: any, link: any) => {
            if(typeof link[1] === "string") acc[link[0]] = link[1]?.replace(`${URL}`, "/")
                else acc[link[0]] = link[1]
            return acc
        },{})
    }

    async function handleCreate(){
        const error = validationCourse(form, langs)
        
        if(error){
            openStatus('error', t(error));
            return
        }

        let action = id ? UpdateCourse : CreateCourse
        
        const response = await action({
            ...form,
            image: form.image ? modifyImageState(form.image) : undefined,
            modules: form.modules?.map((mod: any) => ({
                ...mod,
                image: mod.image ? modifyImageState(mod.image): undefined,
                lessons: mod.lessons?.map((les: any) => ({
                    ...les,
                    preview: les.preview ? modifyImageState(les.preview) : undefined,
                    video: les.video ? modifyImageState(les.video) : undefined
                }))
            }))
        })
        if(response?.data?.message === "course_created" || response?.data?.message === "course_updated"){
            if(deletedLessons?.length) await DeleteLesson({ids: deletedLessons})
            if(deletedModules?.length) await DeleteModule({ids: deletedModules})
            openStatus('success', t(`courses.${response.data.message}`))
            if(id) handleGetCourse(Number(id))
            if(response?.data?.message === "course_created") navigate(`/courses/create?id=${response?.data?.id}`)
        }else openStatus('success', "Error")
    }

    async function handleDelete(id: number){
        const response = await DeleteCourse({id})
        if(response?.data?.message === "course_deleted"){
            openStatus('success', t(`courses.${response.data.message}`))
            navigate('/courses')
        }
        else openStatus('success', "Error")
    }

    // ### Views
    const levels = [
        {
          value: 0,
          label: t("courses.low"),
        },
        {
          value: 50,
          label: t("courses.medium"),
        },
        {
          value: 100,
          label: t("courses.high"),
        },
      ];

    return(
        <div className={s.page}>
            <div className={s.course}>

                <div className={`${s.header} ${dropdown?.main ? s.active : ""}`} onClick={() => setDropDown((prev: any) => ({...prev, main: !prev.main}))}>
                    <div className={`${s.arrow}`}><Arrow/></div>
                    <p className={s.course_title}>{t('courses.course')}</p>
                </div>

                <div className={s.buttons_wrapper}>
                    <PrimaryButton 
                        text={t('general.save')}
                        type={"button"}
                        style={{width: "fit-content"}}
                        onClick={handleCreate}
                        disabled={isCreateLoading || isUpdateLoading || isDeleteLessonLoading || isDeleteModuleLoading || isDeleteCourseLoading}
                    />

                    <SecondaryButton
                        text={t('general.back')}
                        type={"button"}
                        style={{width: "fit-content"}}
                        onClick={() => navigate('/courses/')}
                    />
                    {   form?.id ?
                        <SecondaryButton
                        text={t('general.delete')}
                            icon={<DeleteIcon/>}
                            type={"button"}
                            style={{width: "fit-content"}}
                            onClick={() => setShowDeleteModal(form.id)}
                            disabled={isCreateLoading || isUpdateLoading || isDeleteLessonLoading || isDeleteModuleLoading || isDeleteCourseLoading}
                        /> : null
                    }
                </div>

                <DropdownBlock open={dropdown.main}>
                    <div className={s.column}>
                        <TextFieldsBlock 
                            values={form.name}
                            styles={{width: "100%", maxWidth: "100%"}}
                            title={t('courses.course_name')}
                            changeValue={(value)=> {setForm((prev: any) => ({...prev, name: {...prev.name, ...value}}))}}
                            activeLang={activeLang}
                            setActiveLang={setActiveLang}
                        />
                        
                        <StyledHTMLFieldsBlock 
                            values={form.description}
                            title={t('courses.course_description')}
                            changeValue={(value)=> {
                                console.log("value", value);
                                setForm((prev: any) => ({...prev, description: {...prev.description, ...value}}))}
                            }
                            activeLang={activeLang}
                            setActiveLang={setActiveLang}
                        />
                    </div>

                    <div className={s.row}>
                        <div className={s.item}>
                            <span className={s.title}>
                                <Checkbox 
                                    checked={form.active_price}
                                    onChange={(ev) => setForm((prev: any) => ({...prev, active_price: ev.target.checked}))}
                                />
                                {form.active_price ? t('courses.price') : t('courses.free')}
                            </span>
                            <StyledNumberInput 
                                style={{opacity: form.active_price ? 1 : 0.4}}
                                value={form.price}
                                onChange={(value: any) => setForm((prev: any) => ({...prev, price: value}))}
                            />
                        </div>
                        
                        <div className={s.item}>
                            <span className={s.title}>
                                <Checkbox 
                                    checked={form.active_discount}
                                    onChange={(ev) => setForm((prev: any) => ({...prev, active_discount: ev.target.checked}))}
                                />
                                {form.active_discount ? t('courses.discount') : t('courses.not_discount')}
                            </span>
                            <StyledNumberInput 
                                style={{opacity: form.active_discount ? 1 : 0.4}}
                                value={form.discount}
                                onChange={(value: any) => setForm((prev: any) => ({...prev, discount: value}))}
                            />
                        </div>

                        <div className={s.item}>
                            <span className={s.title}>{t('courses.date_publication')}</span>
                            <DatePicker 
                                showTimeSelect
                                dateFormat="dd.MM.yyyy, HH:mm:ss"
                                selected={new Date(form.date)} 
                                onChange={(date: any) => setForm((prev: any) => ({...prev, date: date.toISOString()}))} 
                            />
                        </div>

                        <div className={`${s.item} ${s.level_item}`} >
                            <span className={s.title}>{t('courses.level')}</span>
                            <Slider
                                track={false}
                                defaultValue={0}
                                value={form.level}
                                getAriaValueText={()=>"valuetext"}
                                step={50}
                                marks={levels}
                                onChange={(_, val) => setForm((prev: any) => ({...prev, level: val}))}
                            />
                        </div>

                        <div className={s.item}>
                            <span className={s.title}>
                                <Checkbox 
                                    checked={form.active_valid_date}
                                    onChange={(ev) => setForm((prev: any) => ({...prev, active_valid_date: ev.target.checked}))}
                                />
                                {t('courses.valid_date')}
                            </span>
                            <StyledNumberInput 
                                style={{opacity: form.active_valid_date ? 1 : 0.4}}
                                value={form.valid_date}
                                onChange={(value: any) => setForm((prev: any) => ({...prev, valid_date: value}))}
                            />
                        </div>
                    </div>

                    <div className={s.row} style={{justifyContent: "flex-start"}}>
                        <div className={s.item}>
                            <span className={s.title}>Tag</span>
                            <Select
                                value={form?.tag || tags?.[0]?.name || false}
                                onChange={(ev)=>{
                                    setForm((prev: any) => ({...prev, tag: ev.target.value}))
                                }}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                {
                                    tags?.map((tag: any, index: number) => (
                                        <MenuItem key={index} value={tag.name}>{tag.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        </div>
                    </div>

                    <div className={s.row}>
                        <div className={`${s.item} ${s.discount_item} ${form.active_discount ? s.active_discount : ""}`} ref={discount_ref}>
                            <StyledHTMLFieldsBlock 
                                style={{width: "100%"}}
                                values={form.discount_text}
                                title={t('courses.not_discount_description')}
                                changeValue={(value)=> setForm((prev: any) => ({...prev, discount_text: {...prev.discount_text, ...value}}))}
                                activeLang={activeLang}
                                setActiveLang={setActiveLang}
                            />
                        </div>
                    </div>
                </DropdownBlock>
            </div>

            <CourseCardBlock 
                form={form} 
                setForm={setForm} 
                activeLang={activeLang} 
                setActiveLang={setActiveLang}
                dropdown={dropdown}
                setDropDown={setDropDown}
            />

            <Modules 
                form={form} 
                setForm={setForm}
                dropdown={dropdown}
                setDropDown={setDropDown}
                setActiveLang={setActiveLang}
                activeLang={activeLang}
                setDeletedLessons={setDeletedLessons}
                setDeletedModules={setDeletedModules}
            />

            <div className={s.footer}>
                <PrimaryButton 
                    text='Save'
                    type={"button"}
                    style={{width: "fit-content"}}
                    onClick={handleCreate}
                    disabled={isCreateLoading || isUpdateLoading || isDeleteLessonLoading || isDeleteModuleLoading}
                />

                <SecondaryButton
                    text='Back'
                    type={"button"}
                    style={{width: "fit-content"}}
                    onClick={() => navigate('/courses/')}
                />
            </div>
            <Skeleton isLoading={isGetLoading}/>

            <ModalGeneral
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                image={questionMark}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
                buttonRight={() => handleDelete(showDeleteModal)}
            />

        </div>
    )
}